const PREVISIONNEL_DEPART = {
  title: 'Prévisionnel de départ',
  tab: {
    numCommande: 'N° commande',
    commercial: 'Commercial',
    assistant: 'Assistant',
    agence: 'Agence',
    annonceur: 'Annonceur',
    theme: 'Thème',
    produit: 'Produit',
    instructionPose: 'Instruction de pose',
    ville: 'Ville',
    dateDebutAffichage: 'Début d\'affichage',
    dateFinAffichage: 'Fin d\'affichage',
    semaine: 'Semaine',
    jourDepart: 'Jour départ',
    nbFacesVendues: 'Nb faces vendues',
    actionLogistique: 'Action',
    datePlanification: 'Réaliser pour',
    nature: 'Nature',
    type: 'Type',
    afficheLivre: 'Affiche réceptionnée',
  },
  actions: {
    nePasAfficherLc: 'Cacher les affectations LC',
    filtre: 'Filtre',
    telechargerPjInstructionPose: 'Télécharger la pièce jointe instruction de pose',
  },
  filtre: {
    type: 'Types',
    agences: 'Agence(s)',
    codesCommandes: 'Code(s) commande(s)',
    instructionPose: 'Instruction de pose',
    afficheLivre: 'Affiche réceptionnée',
    theme: 'Thème',
    libelleReseau: 'Libellé réseau',
    villes: 'Ville(s)',
    datesAffichage: 'Dates d\'affichage',
    semaineVente: 'Semaine de vente',
    jourDepart: 'Jour de départ',
    nbFacesVendues: 'Nombre de faces vendues entre: (min - max)',
  },
  types: {
    devis: 'Devis',
    commande: 'Commande',
    facture: 'Facture',
  },
  info: {
    dateAffichageDiffDatePlanifie: 'La date de début de la ligne de vente ({dateDebut}) est différente de la date de pose planifiée ({datePlanifieeLogistiqueAffichage})',
    dateAffichageIdentiqueLogistique: 'la date de la demande logistique est la même semaine que la date d\'affichage de la vente',
  },
};

export default PREVISIONNEL_DEPART;
